import React from 'react';
import { useAuth } from '@shared/contexts/AuthContext';
import UserManagement from '@/components/UserManagement';

/**
 * Page wrapper for UserManagement — provides auth context as props.
 */
export default function UserManagementPage() {
  const { user } = useAuth();

  const currentUser = user ? {
    id: user.id,
    dbId: user.id,
    authId: user.auth_id,
    email: user.email,
    name: user.name || `${user.first_name || ''} ${user.surname || ''}`.trim(),
    role: user.role,
  } : null;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <UserManagement currentUser={currentUser} />
    </div>
  );
}
